import { gql } from "@apollo/client";

const MATCH_HISTORY_SEARCH = gql`
  query PlayerSearchNew($count: Float, $query: String!) {
    playerSearchNew(query: $query, count: $count) {
      gameId
      avatar
      displayName
    }
  }
`;

export { MATCH_HISTORY_SEARCH };
